/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContractualAccountStatus = 'Undefined' | 'Effective' | 'Terminated';

export const ContractualAccountStatus = {
    Undefined: 'Undefined' as ContractualAccountStatus,
    Effective: 'Effective' as ContractualAccountStatus,
    Terminated: 'Terminated' as ContractualAccountStatus
};